import { useEffect } from 'react';
import { useLocation, Location } from 'react-router-dom';
import { BehaviorSubject, map } from 'rxjs';

export const history$ = new BehaviorSubject<Location<any> | null>(null);
export const pathname$ = history$.pipe(
  map((location) => location?.pathname ?? '/')
);

export const useOnLocationChange = () => {
  const location = useLocation();
  useEffect(() => history$.next(location), [location]);
};
